import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { footerData } from '../data/mock';

const socialIcons = {
  Instagram,
  Twitter,
  LinkedIn: Linkedin,
};

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0F] pt-16 pb-8 border-t border-[#2A2A35]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#FF6B35] to-[#FF8555] flex items-center justify-center">
                <span className="text-black font-bold">DP</span>
              </div>
              <span className="text-white font-semibold text-xl">{footerData.brand}</span>
            </Link>
            <p className="text-[#6B6B78] mb-6 max-w-sm">
              {footerData.tagline} We build high-performance websites that convert your social media followers into real business results.
            </p>
            <div className="flex gap-3">
              {footerData.social.map((social) => {
                const IconComponent = socialIcons[social.platform];
                return (
                  <a 
                    key={social.platform}
                    href={social.href}
                    className="w-10 h-10 rounded-lg bg-[#12121A] border border-[#2A2A35] flex items-center justify-center text-[#B8B8C0] hover:text-[#FF6B35] hover:border-[#FF6B35]/30 transition-colors"
                  >
                    <IconComponent size={18} />
                  </a>
                );
              })}
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <nav className="space-y-3">
              <a href="#features" className="block text-[#6B6B78] hover:text-[#FF6B35] transition-colors">
                Features
              </a>
              <a href="#how-it-works" className="block text-[#6B6B78] hover:text-[#FF6B35] transition-colors">
                How It Works
              </a>
              <a href="#about" className="block text-[#6B6B78] hover:text-[#FF6B35] transition-colors">
                About
              </a>
              <Link to="/contact" className="block text-[#6B6B78] hover:text-[#FF6B35] transition-colors">
                Contact
              </Link>
            </nav>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>
            <div className="space-y-3">
              <a 
                href="mailto:duke.pettijohn@icloud.com"
                className="flex items-center gap-2 text-[#6B6B78] hover:text-[#FF6B35] transition-colors"
              >
                <Mail size={16} />
                <span>duke.pettijohn@icloud.com</span>
              </a>
              <a 
                href="tel:+14693831834"
                className="flex items-center gap-2 text-[#6B6B78] hover:text-[#FF6B35] transition-colors"
              >
                <Phone size={16} />
                <span>(469) 383-1834</span>
              </a>
              <div className="flex items-start gap-2 text-[#6B6B78]">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Florida, USA</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="pt-8 border-t border-[#2A2A35]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#6B6B78]">
              © {new Date().getFullYear()} {footerData.brand}. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-[#6B6B78] hover:text-[#FF6B35] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-[#6B6B78] hover:text-[#FF6B35] transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
